import { memo } from "react";
import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export const GraficoSetup = memo(function GraficoSetup({ data, printing, type, index }) {
    let setup = [...data.setup];
    let quantidades = [];
    let tempos = [];
    let medias = [];
    let labels = [];

    setup.forEach(element => {
        if (element.nome === type) {
            labels.push([element.label, element.nome]);
            quantidades.push(element.quantidade);
            tempos.push(element.tempo);
            medias.push(element.media.toFixed(2));
        }
    });

    const chartData = {
        labels: labels,
        datasets: [{
            label: 'Quantidades',
            data: quantidades,
            backgroundColor: '#e74c3c'
        },
        {
            label: 'Tempo',
            data: tempos,
            backgroundColor: '#2ecc71',
        },
        {
            label: 'Média',
            data: medias,
            backgroundColor: '#3498db',
        }
        ]
    }

    return (
        <Chart
            id={`GraficoSetup${index}`}
            data={chartData}
            height={printing ? "210mm" : "650px"}
            width={printing ? "297mm" : "100%"}
            options={{
                maintainAspectRatio: false,
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        align: 'end',
                        font: {
                            size: 24,
                            weight: 'bold'
                        },
                        color: "#2c3e50"
                    },
                    title: {
                        display: true,
                        text: 'Gráfico de ' + type + ' - ' + data.periodo,
                        font: {
                            size: 18
                        }
                    }
                },
            }}
            plugins={[ChartDataLabels]}
            type="bar"
        />
    )
});